import {Role, RouteName, Viewport} from '@/utils/enums';
import LoginPage from '@/pages/login.page.vue';
import LoginCallBackPage from '@/pages/login-callback.page.vue';

export const routes = [
  {
    path: '/',
    name: RouteName.LOGIN,
    component: LoginPage,
    meta: {
      pageTitle: 'Login',
      pageLevel: 1,
      authRequired: false,
      layout: {
        nav: {
          visible: false
        },
        header: {
          visible: false,
          transparent: true,
          menuVisible: true,
          logoVisible: true,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: '',
            main: '',
            sub: ''
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    }
  },
  {
    path: '/login-callback',
    name: RouteName.LOGIN_CALLBACK,
    component: LoginCallBackPage,
    meta: {
      pageTitle: 'login-callback',
      pageLevel: 1,
      authRequired: false,
      layout: {
        nav: {
          visible: false
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: false,
          logoVisible: true,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: '',
            main: '',
            sub: ''
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    }
  },
  {
    path: '/lost-password',
    name: RouteName.LOST_PASSWORD,
    component: () =>
      import(
        /* webpackChunkName: "lostpassword" */ '../pages/lostpassword.page.vue'
      ),
    meta: {
      pageTitle: 'Wachtwoord vergeten',
      pageLevel: 2,
      authRequired: false,
      layout: {
        nav: {
          visible: false
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: false,
          logoVisible: true,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: '',
            main: '',
            sub: ''
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    }
  },
    // authRequired from here
  {
    path: '/home',
    name: RouteName.HOME,
    meta: {
      pageTitle: 'Home',
      pageLevel: 1,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL, Role.MELDKAMER_MEDEWERKER, Role.MILES_BEHEERDER],
      layout: {
        nav: {
          visible: false
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: true,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: '',
            main: '',
            sub: ''
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
      import(/* webpackChunkName: "home" */ '../pages/home.page.vue')
  },
  {
    path: '/connect',
    name: RouteName.CONNECT,
    meta: {
      pageTitle: 'Connect',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-smartwatch',
            main: 'Smartwatch Uitgeven',
            sub: 'Selecteer een smartwatch om uit te geven'
          },
          wizard: {
            visible: false,
            activeStep: 1,
            steps: 3
          }
        }
      }
    },
    component: () =>
      import(/* webpackChunkName: "connect" */ '../pages/connect.page.vue')
  },
  {
    path: '/connect-settings',
    name: RouteName.CONNECT_SETTINGS,
    meta: {
      pageTitle: 'Reis instellingen',
      pageLevel: 3,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Selecteer een smartwatch',
          headerText: {
            icon: 'header-smartwatch',
            main: 'Smartwatch Uitgeven',
            sub: 'Instellen terugkeertijdstip'
          },
          wizard: {
            visible: false,
            activeStep: 2,
            steps: 3
          }
        }
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "connect-settings" */ '../pages/connect-settings.page.vue'
      )
  },
  {
    path: '/connect-clients',
    name: RouteName.CONNECT_CLIENT,
    meta: {
      pageTitle: 'Selecteer client',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: [Viewport.DESKTOP, Viewport.MOBILE],
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Selecteer een smart watch',
          headerText: {
            icon: 'header-smartwatch',
            main: 'Smartwatch Uitgeven',
            sub: 'Selecteer een Cliënt om te koppelen'
          },
          wizard: {
            visible: false,
            activeStep: 2,
            steps: 3
          }
        }
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "connect-settings" */ '../pages/connect-clients.page.vue'
      )
  },
  {
    path: '/connect-select-map-area',
    name: RouteName.CONNECT_SELECT_MAP_AREA,
    meta: {
      pageTitle: 'Gebied instellen',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-smartwatch',
            main: 'Gebied instellen',
            sub: 'Wijs op de kaart de locaties aan waar de cliënt naar toe wil'
          },
          wizard: {
            visible: false,
            activeStep: 1,
            steps: 2
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "unconnect" */ '../pages/connect.area.page.vue')
  },
  {
    path: '/connect-complete',
    name: RouteName.CONNECT_COMPLETE,
    meta: {
      pageTitle: 'Koppelen gereed',
      pageLevel: 4,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL],
      layout: {
        nav: {
          visible: false
        },
        header: {
          visible: true,
          transparent: true,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: '',
            main: '',
            sub: ''
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "connect-complete" */ '../pages/connect-complete.page.vue'
      )
  },
  {
    path: '/smartwatch-overview-page',
    name: RouteName.SMARTWATCH_OVERVIEW,
    meta: {
      pageTitle: 'Actieve smartwatches',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-smartwatch',
            main: 'Actieve smartwatches',
            sub: 'Selecteer een smartwatch om de instellingen te wijzigen/ bekijken, of om in te nemen'
          },
          wizard: {
            visible: false,
            activeStep: 1,
            steps: 2
          }
        }
      }
    },
    component: () =>
      import(/* webpackChunkName: "unconnect" */ '../pages/smartwatch-overview.page.vue')
  },
  {
    path: '/active-smartwatch-settings-page',
    name: RouteName.ACTIVE_SMARTWATCH_SETTINGS,
    meta: {
      pageTitle: 'Wijzigen instellingen actieve smartwatch',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-smartwatch',
            main: 'Actieve smartwatch',
            sub: 'Wijzig de instellingen van deze actieve smartwatch, of neem hem in'
          },
          wizard: {
            visible: false,
            activeStep: 1,
            steps: 2
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "active-smartwatch-settings-page" */ '../pages/active-smartwatch-settings.page.vue')
  },
  {
    path: '/unconnect-note',
    name: RouteName.UNCONNECT_NOTE,
    meta: {
      pageTitle: 'Smartwatch Innemen',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-smartwatch',
            main: 'Smartwatch Innemen',
            sub: 'Voer eventuele opmerkingen in'
          },
          wizard: {
            visible: false,
            activeStep: 2,
            steps: 2
          }
        }
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "unconnect-note" */ '../pages/unconnect-note.page.vue'
      )
  },
  {
    path: '/unconnect-complete',
    name: RouteName.UNCONNECT_COMPLETE,
    meta: {
      pageTitle: 'Smartwatch Innemen',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: '',
            main: '',
            sub: ''
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "unconnect-complete" */ '../pages/unconnect-complete.page.vue'
      )
  },
  {
    path: '/notifications',
    name: RouteName.NOTIFICATIONS,
    meta: {
      pageTitle: 'Overzicht alarmeringen',
      pageLevel: 2,
      authorize: [Role.ZORG_PROFESSIONAL, Role.MELDKAMER_MEDEWERKER],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-alarm',
            main: 'Overzicht alarmeringen',
            sub: ''
          },
          wizard: {
            visible: false,
            activeStep: 1,
            steps: 2
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "unconnect" */ '../pages/notifications.page.vue')
  },
  {
    path: '/notification-detail-page',
    name: RouteName.NOTIFICATION_DETAIL,
    meta: {
      pageTitle: 'Volgen navigatie',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL, Role.MELDKAMER_MEDEWERKER],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: '',
            main: 'Overzicht alarmering',
            sub: ''
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "follow-navigate" */ '../pages/notification-detail.page.vue'
      )
  },
  {
    path: '/settings',
    name: RouteName.SETTINGS,
    meta: {
      pageTitle: 'Instellingen',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-settings',
            main: 'Miles.',
            sub: 'Persoonlijke Instellingen'
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
      import(/* webpackChunkName: "settings" */ '../pages/settings.page.vue')
  },
  {
    path: '/admin-page',
    name: RouteName.ADMIN,
    meta: {
      pageTitle: 'Beheer',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL, Role.MILES_BEHEERDER],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-admin',
            main: 'Beheer',
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "settings" */ '../pages/admin/admin.page.vue')
  },
  {
    path: '/admin-clients-page',
    name: RouteName.ADMIN_CLIENTS,
    meta: {
      pageTitle: '“Beheer Cliënten',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-admin',
            main: 'Beheer Cliënten',
            sub: 'Voeg nieuwe cliënten toe die gebruik mogen maken van de smartwatch of wijzig / verwijder bestaande'
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "settings" */ '../pages/admin/admin.clients.page.vue')
  },
  {
    path: '/admin-new-client-page',
    name: RouteName.ADMIN_NEW_CLIENT,
    meta: {
      pageTitle: 'Cliënt toevoegen',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.ZORG_PROFESSIONAL],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-admin',
            main: 'Cliënt toevoegen',
            sub: ''
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "settings" */ '../pages/admin/admin.clients.new.page.vue')
  },
    {
        path: '/admin-edit-client-page',
        name: RouteName.ADMIN_EDIT_CLIENT,
        meta: {
            pageTitle: 'Cliëntprofiel bewerken',
            pageLevel: 2,
            authRequired: true,
            authorize: [Role.ZORG_PROFESSIONAL],
            layout: {
                nav: {
                    visible: true
                },
                header: {
                    visible: true,
                    transparent: false,
                    menuVisible: true,
                    logoVisible: false,
                    backButtonText: 'Terug naar home',
                    headerText: {
                        icon: 'header-admin',
                        main: 'Cliënt wijzigen / verwijderen',
                        sub: ''
                    },
                    wizard: {
                        visible: false,
                        activeStep: 3,
                        steps: 3
                    }
                }
            }
        },
        component: () =>
            import(/* webpackChunkName: "settings" */ '../pages/admin/admin.clients.edit.page.vue')
    },
  {
    path: '/admin-smartwatches-page',
    name: RouteName.ADMIN_SMARTWATCHES,
    meta: {
      pageTitle: 'Beheer Smartwatches',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.MILES_BEHEERDER],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-admin',
            main: 'Beheer Smartwatches',
            sub: 'Voeg nieuwe smartwatch toe of wijzig / verwijder bestaande smartwatch'
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "settings" */ '../pages/admin/admin.smartwatches.page.vue')
  },
  {
    path: '/admin-new-smartwatch-page',
    name: RouteName.ADMIN_NEW_SMARTWATCH,
    meta: {
      pageTitle: 'Smartwatch toevoegen',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.MILES_BEHEERDER],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-admin',
            main: 'Smartwatch toevoegen',
            sub: ''
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "settings" */ '../pages/admin/admin.smartwatch.new.page.vue')
  },
  {
    path: '/admin-edit-smartwatch-page',
    name: RouteName.ADMIN_EDIT_SMARTWATCH,
    meta: {
      pageTitle: 'Smartwatch wijzigen / verwijderen',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.MILES_BEHEERDER],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-admin',
            main: 'Smartwatch wijzigen / verwijderen',
            sub: ''
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "settings" */ '../pages/admin/admin.smartwatch.edit.page.vue')
  },
  {
    path: '/admin-locations-page',
    name: RouteName.ADMIN_LOCATIONS,
    meta: {
      pageTitle: 'Beheer woonlocaties',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.MILES_BEHEERDER],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-admin',
            main: 'Beheer woonlocaties',
            sub: 'Voeg nieuwe woonlocatie toe of wijzig / verwijder bestaande'
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "settings" */ '../pages/admin/admin.location.page.vue')
  },
  {
    path: '/admin-new-location-page',
    name: RouteName.ADMIN_NEW_LOCATION,
    meta: {
      pageTitle: 'Woonlocatie toevoegen',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.MILES_BEHEERDER],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-admin',
            main: 'Woonlocatie toevoegen',
            sub: ''
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "settings" */ '../pages/admin/admin.location.new.page.vue')
  },
  {
    path: '/admin-location-edit-page',
    name: RouteName.ADMIN_EDIT_LOCATION,
    meta: {
      pageTitle: 'Woonlocatie wijzigen / verwijderen',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.MILES_BEHEERDER],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-admin',
            main: 'Woonlocatie wijzigen / verwijderen',
            sub: ''
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "settings" */ '../pages/admin/admin.locations.edit.page.vue')
  },
  {
    path: '/admin-employees-page',
    name: RouteName.ADMIN_EMPLOYEES,
    meta: {
      pageTitle: 'Beheer Zorg Professionals',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.MILES_BEHEERDER],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-admin',
            main: 'Beheer Zorg Professionals',
            sub: 'Beheer de Zorg Professionals die toegang tot de applicatie hebben'
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "settings" */ '../pages/admin/admin.employees.page.vue')
  },
  {
    path: '/admin-edit-employee-page',
    name: RouteName.ADMIN_EDIT_EMPLOYEE,
    meta: {
      pageTitle: 'Wijzigen profiel Zorg Professional',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.MILES_BEHEERDER],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-admin',
            main: 'Wijzigen profiel Zorg Professional',
            sub: 'Wijzigen profiel Zorg Professional'
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "settings" */ '../pages/admin/admin.employee.edit.page.vue')
  },
  {
    path: '/admin-meldkamer-settings-page',
    name: RouteName.ADMIN_MELDKAMER_SETTINGS,
    meta: {
      pageTitle: 'Meldkamer instellingen',
      pageLevel: 2,
      authRequired: true,
      authorize: [Role.MILES_BEHEERDER],
      layout: {
        nav: {
          visible: true
        },
        header: {
          visible: true,
          transparent: false,
          menuVisible: true,
          logoVisible: false,
          backButtonText: 'Terug naar home',
          headerText: {
            icon: 'header-admin',
            main: 'Wijzigen instellingen Meldkamer'
          },
          wizard: {
            visible: false,
            activeStep: 3,
            steps: 3
          }
        }
      }
    },
    component: () =>
        import(/* webpackChunkName: "settings" */ '../pages/admin/admin.meldkamer.settings.page.vue')
  }
];
